const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Resolve a single asset URL (image, PDF) so it always points to the running backend.
 *  - Absolute URLs (http/https) are returned unchanged
 *  - Relative `/api/...` paths are prefixed with REACT_APP_BACKEND_URL
 *
 * The DB stores RELATIVE paths only, so when the deployed domain changes nothing breaks.
 */
export const resolveAssetUrl = (url) => {
    if (!url) return url;
    if (/^https?:\/\//i.test(url)) return url;
    if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
    return url;
};

/**
 * Inside rich HTML content (Quill output) rewrite every <img src> that points to
 * `/api/files/...` (or to ANY backend URL we recognize) so it always points to the
 * current REACT_APP_BACKEND_URL. This keeps content portable across deployments
 * where the domain changed after publishing.
 */
export const resolveContentHtml = (html) => {
    if (!html || typeof html !== "string") return html;
    // 1) Strip ANY absolute backend URL before /api/files/ → makes it relative
    let out = html.replace(/(src|href)="https?:\/\/[^"]*?(\/api\/files\/)/gi, '$1="$2');
    // 2) Now prepend BACKEND_URL to every relative /api/files/
    if (BACKEND_URL) {
        out = out.replace(/(src|href)="(\/api\/files\/)/gi, `$1="${BACKEND_URL}$2`);
    }
    return out;
};

/**
 * Extract the URL of the FIRST image embedded in a chunk of HTML.
 * Used to pick an og:image when a post has no dedicated cover.
 * Returns an absolute URL (or "" if nothing found).
 */
export const extractFirstImageUrl = (html) => {
    if (!html || typeof html !== "string") return "";
    const m = html.match(/<img[^>]+src=["']([^"']+)["']/i);
    if (!m) return "";
    return resolveAssetUrl(m[1].replace(/^https?:\/\/[^/]+(\/api\/files\/)/i, "$1"));
};
